import { useLocation, useNavigate } from "react-router-dom";

import { langPath, useLang, useTranslation } from "@/i18n";

export const Imprint = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lang = useLang();
  const t = useTranslation();

  const state = (location.state as { from: { pathname: string } }) || {};

  const handleGoBack = () => {
    const { from = { pathname: langPath("/", lang) } } = state;

    if (from === undefined || from.pathname === location.pathname) {
      navigate(langPath("/", lang), { replace: true });
      return;
    }

    navigate(from, { replace: true });
  };

  return (
    <div className="flex flex-1 flex-col py-safe-or-4 bg-[#1d2128] text-white">
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="flex flex-col space-y-2 p-4 text-center">
          <h1 className="font-display text-5xl font-bold">
            {t.imprint.title}
          </h1>
          <p className="text-md p-4">
            <strong>{t.imprint.tmg}</strong><br />
            ROCKNITIVE GmbH<br />
            Holländerkoppel 19 a<br />
            23858 Reinfeld<br />
            info@rocknitive.com
          </p>
          <p className="text-md p-4">
            <strong>{t.imprint.directors}</strong><br />
            Mike Lohmann<br />
            Christian Eichinger
          </p>
          <p className="text-md p-4">
            <strong>{t.imprint.court}</strong><br />
            {t.imprint.courtValue}
          </p>
          <p className="text-md p-4">
            <strong>{t.imprint.regNumber}</strong><br />
            HRB 19872 HL
          </p>
          <p className="text-md p-4">
            <strong>{t.imprint.responsible}</strong><br />
            Mike Lohmann
          </p>
        </div>
      </div>
      <div className="flex justify-center">
        <button className="w-1/2" onClick={handleGoBack}>
          {t.imprint.back}
        </button>
      </div>
    </div>
  );
};
